<template>
  <layout-main-inner
    v-loading="loading"
    title="标签发放记录">
    <el-button
      slot="action"
      type="primary"
      @click="fetchList">刷新</el-button>
    <layout-card-wrap>
      <el-table
        border
        :data="list">
        <el-table-column
          label="鉴定中心"
          min-width="240"
          prop="roomName"></el-table-column>
        <el-table-column
          label="领取总数"
          min-width="100"
          prop="tagCount"></el-table-column>
        <el-table-column
          label="使用总数"
          min-width="100"
          prop="usedTagCount"></el-table-column>
        <el-table-column
          label="未使用总数"
          min-width="100"
          :formatter="row => row.tagCount - row.usedTagCount"
          prop="usedTagCount"></el-table-column>
        <el-table-column
          label="操作"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="cancelAllocationLabel(row)">发放记录</el-button>
          </template>
        </el-table-column>
      </el-table>
    </layout-card-wrap>

    <label-allocation-modal ref="allocation" />
  </layout-main-inner>
</template>
<script>
import AppraiseLable from '../../../service/appraiseLable'
import LabelAllocationModal from './label-allocation/label-allocation-modal.vue'
export default {
  name: 'LabelAllocation',
  components: { LabelAllocationModal },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 100 }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    cancelAllocationLabel(row) {
      const { roomId, roomName } = row
      this.$refs.allocation.fetch({ roomId, roomName })
    },
    fetchList() {
      this.loading = true
      AppraiseLable.getroomtagassigns({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
